module.exports = __webpack_public_path__ + "static/media/18.5ebe38e7.jpg";